<div class="organisation-contracts-tab" data-testid="organisation-contracts-tab">
    @if (!isActive) {
        <div class="alert alert-info" role="status" data-testid="organisation-contracts-inactive">
            This organisation is {{ organisation?.deletedAt ? 'deleted' : 'deactivated' }}. Linked contracts cannot be viewed or changed.
        </div>
    } @else if (loading) {
        <spinner></spinner>
    } @else {
        @if (loadError) {
            <div class="alert alert-warning" role="alert" data-testid="organisation-contracts-error">{{ loadError }}</div>
        } @else if (rows.length === 0) {
            <p class="text-muted" data-testid="organisation-contracts-empty">No contracts linked</p>
        } @else {
            <div class="table-responsive">
                <table class="table table-sm align-middle" data-testid="organisation-contracts-table">
                    <caption class="visually-hidden">Contracts linked to this organisation</caption>
                    <thead>
                        <tr>
                            <th scope="col">Title</th>
                            <th scope="col">Code</th>
                            <th scope="col">Service provider</th>
                            <th scope="col">Signature date</th>
                            <th scope="col">Kickoff date</th>
                            @if (canWrite) {
                                <th scope="col">Actions</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (row of rows; track row.id) {
                            <tr data-testid="organisation-contract-row">
                                <td>
                                    @if (canViewContract) {
                                        <a [routerLink]="contractLink(row)" data-testid="organisation-contract-link">{{ row.title }}</a>
                                    } @else {
                                        <span data-testid="organisation-contract-title">{{ row.title }}</span>
                                    }
                                    @if (contractStatus(row)) {
                                        <span class="badge ms-2" [class.badge-deleted]="contractStatus(row) === 'Deleted'" [class.badge-deactivated]="contractStatus(row) === 'Deactivated'" data-testid="organisation-contract-status">{{ contractStatus(row) }}</span>
                                    }
                                </td>
                                <td>{{ row.code }}</td>
                                <td>{{ row.serviceProvider }}</td>
                                <td>{{ row.signatureDate | date: 'dd/MM/yyyy' }}</td>
                                <td>{{ row.kickoffDate | date: 'dd/MM/yyyy' }}</td>
                                @if (canWrite) {
                                    <td>
                                        <button type="button" class="btn btn-link link-danger p-0 align-baseline"
                                                [attr.aria-label]="'Unlink ' + row.title"
                                                [disabled]="removing"
                                                confirmHeader="Confirm the action"
                                                confirmModal="Are you sure you want to unlink the selected contract from this organisation?"
                                                confirmMessage=""
                                                confirmOk="Yes, proceed"
                                                confirmCancel="No, cancel"
                                                confirmOkClass="btn-outline-danger"
                                                confirmCancelClass="btn-gray text-dark"
                                                [confirmCancelFirst]="true"
                                                (confirmedClick)="unlink(row)"
                                                data-testid="organisation-contract-unlink">
                                            <i class="bi bi-x-lg" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
        @if (canWrite) {
            <div class="organisation-contracts-actions">
                <button type="button" class="btn btn-success" #linkButton
                        [disabled]="removing"
                        (click)="openLinkModal()"
                        data-testid="organisation-contracts-link">
                    <i class="bi bi-link-45deg me-2" aria-hidden="true"></i>Link contracts
                </button>
            </div>
        }
    }
</div>
